module.exports = __webpack_public_path__ + "static/media/faqBalance-en-tl.fc7930df.vtt";